<!--
    @Author : Luo
    @Time   : 2020/7/14 18:11
-->
<template>
  <div class="page_data_overview">
    <div class="day_active_container flex_center">
      <div class="client_active_header flex_center">
        <div class="day_active_user_icon">
          <svg-icon :iconClass="'data_user'"
            :className="'icon_down_style svg_icon_special color_grey'"></svg-icon>
        </div>
        <div class="client_active_data flex_center"><span>日活跃帐号</span><span>{{ activeUser.day.active }}</span></div>
        <div class="client_active_info">
          <div class="today_container text_left"><span>本日 {{ activeUser.time }}</span></div>
          <div class="statistics_container flex_center">
            <div class="statistics_mom flex_center">
              <div class="statistics_mom_label"><span>日环比</span></div>
              <div class="statistics_mom_info"><span>{{ resetSpecNum(Math.abs(activeUser.day.mom)) }}%</span></div>
              <div class="statistics_mom_icon">
                <span v-if="activeUser.day.mom === 0">--</span>
                <svg-icon v-else :iconClass="activeUser.day.mom < 0 ? 'icon_triangle_down' : 'icon_triangle_top'"
                          :className="'icon_down_style svg_icon_xs ' + (activeUser.day.mom < 0 ? 'color_green' : 'color_red')"></svg-icon>
              </div>
            </div>
            <div class="statistics_yoy flex_center">
              <div class="statistics_mom_label"><span>日同比</span></div>
              <div class="statistics_mom_info"><span>{{ resetSpecNum(Math.abs(activeUser.day.yoy)) }}%</span></div>
              <div class="statistics_mom_icon">
                <span v-if="activeUser.day.yoy === 0">--</span>
                <svg-icon v-else :iconClass="activeUser.day.yoy < 0 ? 'icon_triangle_down' : 'icon_triangle_top'"
                          :className="'icon_down_style svg_icon_xs ' + (activeUser.day.yoy < 0 ? 'color_green' : 'color_red')"></svg-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="client_active_container flex_center">
      <div class="client_active_main flex_center">
        <div class="chart_container">
          <div class="client_active_cycle_container">
            <div class="client_active_cycle_nav flex_center">
              <div class="client_active_cycle_header flex_center">
                <div class="client_active_cycle_label flex_center">
                  <span>活跃帐号</span>
                  <div class="active_detail_icon">
                    <span @click="catActiveDetail">
                      <svg-icon class-name="icon_down_style svg_icon_xs color_102 pointer_none"
                        icon-class="icon_info"></svg-icon>
                    </span>
                    <div class="active_detail" @click="$event.stopPropagation()" v-show="activeDetail">
                      <div class="active_detail_container">
                        <span>周/月活跃帐号=等于去重后的活跃帐号数之和（周活跃的定义为周登录大于等于3次，<br />月活跃定义为月登录大于等于12）</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="client_active_cycle_info"><span>{{ activeAccessStatus ? activeUser.month.active : activeUser.week.active }}</span></div>
              </div>
              <div class="statistics_nav flex_center" :name="activeAccessStatus ? '月' : '周'">
                <div :class="['statistics_nav_data', {'statistics_nav_active': !activeAccessStatus}]" @click="changeChart('act', false, 'act-d')"><span>周活</span></div>
                <div :class="['statistics_nav_month', {'statistics_nav_active': activeAccessStatus}]" @click="changeChart('act', true, 'act-m')"><span>月活</span></div>
              </div>
            </div>
            <div class="statistics_container flex_center">
              <div class="statistics_mom flex_center">
                <div class="statistics_mom_label"><span>{{ activeAccessStatus ? '月环比' : '周环比' }}</span></div>
                <div class="statistics_mom_info"><span>{{ activeAccessStatus ? Math.abs(activeUser.month.mom) : Math.abs(activeUser.week.mom) }}%</span></div>
                <div class="statistics_mom_icon" v-show="activeAccessStatus">
                  <span v-if="activeUser.month.mom === 0">--</span>
                  <svg-icon v-else :iconClass="activeUser.month.mom < 0 ? 'icon_triangle_down' : 'icon_triangle_top'"
                    :className="'icon_down_style svg_icon_xs ' + (activeUser.month.mom < 0 ? 'color_green' : 'color_red')"></svg-icon>
                </div>
                <div class="statistics_mom_icon" v-show="!activeAccessStatus">
                  <span v-if="activeUser.week.mom === 0">--</span>
                  <svg-icon v-else :iconClass="activeUser.week.mom < 0 ? 'icon_triangle_down' : 'icon_triangle_top'"
                            :className="'icon_down_style svg_icon_xs ' + (activeUser.week.mom < 0 ? 'color_green' : 'color_red')"></svg-icon>
                </div>
              </div>
              <div class="statistics_yoy flex_center">
                <div class="statistics_mom_label"><span>{{ activeAccessStatus ? '月同比' : '周同比' }}</span></div>
                <div class="statistics_mom_info"><span>{{ activeAccessStatus ? Math.abs(activeUser.month.yoy) : Math.abs(activeUser.week.yoy) }}%</span></div>
                <div class="statistics_mom_icon" v-show="activeAccessStatus">
                  <span v-if="activeUser.month.yoy === 0">--</span>
                  <svg-icon v-else :iconClass="activeUser.month.yoy < 0 ? 'icon_triangle_down' : 'icon_triangle_top'"
                            :className="'icon_down_style svg_icon_xs ' + (activeUser.month.yoy < 0 ? 'color_green' : 'color_red')"></svg-icon>
                </div>
                <div class="statistics_mom_icon" v-show="!activeAccessStatus">
                  <span v-if="activeUser.week.yoy === 0">--</span>
                  <svg-icon v-else :iconClass="activeUser.week.yoy < 0 ? 'icon_triangle_down' : 'icon_triangle_top'"
                            :className="'icon_down_style svg_icon_xs ' + (activeUser.week.yoy < 0 ? 'color_green' : 'color_red')"></svg-icon>
                </div>
              </div>
            </div>
          </div>
          <div v-show="!activeAccessStatus" id="chart_active_day" class="chart_main"></div>
          <div v-show="activeAccessStatus" id="chart_active_month" class="chart_main"></div>
        </div>
      </div>
      <div class="client_active_cycle_main">
        <div class="time_container flex_center" v-show="!activeAccessStatus">
          <div class="time_input"><span ref="client_active_data_start" id="client_active_data_start"> {{ timeEl.activeData[0] }} </span></div>
          <div class="range_icon">
            <svg-icon iconClass="icon_range" className="icon_down_style svg_icon_xs color_219"></svg-icon>
          </div>
          <div class="time_input"><span ref="client_active_data_end" id="client_active_data_end">{{ timeEl.activeData[1] }}</span></div>
        </div>
        <div class="time_container flex_center time_month_container" v-show="activeAccessStatus">
          <div class="time_input"><span ref="client_active_month_start" id="client_active_month_start"> {{ timeEl.activeMonth[0] }} </span></div>
        </div>
        <div class="client_active_user">
          <div class="client_active_user_header flex_center">
            <div><span>活跃帐号</span></div>
            <div><span>客户数量</span></div>
            <div><span>活跃度</span></div>
            <div><span></span></div>
          </div>
          <div class="client_active_user_main">
            <div class="no_user_hint" v-if="modalActiveDate.length <= 0"><span>{{ noDataHint }}</span></div>
            <template v-for="(item, i) of modalActiveDate">
              <div class="client_active_user_container flex_center" @click="catUserInfo(item)" :key="i">
                <div><span>{{ item.userName }}</span></div>
                <div><span>{{ item.clientNum }}</span></div>
                <div><span>{{ item.active_num }}</span></div>
                <div><svg-icon :className="'icon_down_style svg_icon_xs color_102 pointer_none'" :iconClass="'select_up'"></svg-icon></div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="access_container flex_center">
      <div class="login_access_container">
        <div class="access_header flex_center">
          <div class="access_header_label"><span>登录页访问量</span></div>
          <div class="access_header_info"><span>{{ loginDate.totalNum }}</span></div>
        </div>
        <div class="access_content flex_center">
          <div class="statistics_nav flex_center">
            <div :class="['statistics_nav_data', {'statistics_nav_active': !loginAccessStatus}]" @click="changeChart('log', false, 'log-d')"><span>日度</span></div>
            <div :class="['statistics_nav_month', {'statistics_nav_active': loginAccessStatus}]" @click="changeChart('log', true, 'log-m')"><span>月度</span></div>
          </div>
          <div v-show="!loginAccessStatus" class="time_container flex_center">
            <div class="time_input"><span ref="login_access_data_start" id="login_access_data_start"> {{ timeEl.loginAccessData[0] }} </span></div>
            <div class="range_icon">
              <svg-icon iconClass="icon_range" className="icon_down_style svg_icon_xs color_219"></svg-icon>
            </div>
            <div class="time_input"><span ref="login_access_data_end" id="login_access_data_end">{{ timeEl.loginAccessData[1] }}</span></div>
          </div>
          <div v-show="loginAccessStatus" class="time_container flex_center">
            <div class="time_input"><span ref="login_access_month_start" id="login_access_month_start"> {{ timeEl.loginAccessMonth[0] }} </span></div>
            <div class="range_icon">
              <svg-icon iconClass="icon_range" className="icon_down_style svg_icon_xs color_219"></svg-icon>
            </div>
            <div class="time_input"><span ref="login_access_month_end" id="login_access_month_end">{{ timeEl.loginAccessMonth[1] }}</span></div>
          </div>
        </div>
        <div class="access_main">
          <div class="week_chart" v-show="!loginAccessStatus"><div id="chart_login_access_data" class="chart_main"></div></div>
          <div class="month_chart" v-show="loginAccessStatus"><div id="chart_login_access_month" class="chart_main"></div></div>
        </div>
        <div class="access_footer flex_center">
          <div class="today_container"><span>{{ loginAccessStatus ? '本月 ' + loginMonthDate.currentMonth : '本日 ' + loginDate.currentDay }}</span></div>
          <div class="statistics_container flex_center">
            <div class="statistics_mom flex_center">
              <div class="statistics_mom_label"><span>{{ loginAccessStatus ? '月环比' : '日环比' }}</span></div>
              <div class="statistics_mom_info"><span>{{ loginAccessStatus ? Math.abs(loginMonthDate.currentMOM) : Math.abs(loginDate.currentMOM) }}%</span></div>
              <div v-if="!loginAccessStatus" class="statistics_mom_icon">
                <span v-if="loginDate.currentMOM === 0">--</span>
                <svg-icon v-else :iconClass="loginDate.currentMOM < 0 ? 'icon_triangle_down' : 'icon_triangle_top'"
                          :className="'icon_down_style svg_icon_xs ' + (loginDate.currentMOM < 0 ? 'color_green' : 'color_red')"></svg-icon>
              </div>
              <div v-else class="statistics_mom_icon">
                <span v-if="loginMonthDate.currentMOM === 0">--</span>
                <svg-icon v-else :iconClass="loginMonthDate.currentMOM < 0 ? 'icon_triangle_down' : 'icon_triangle_top'"
                          :className="'icon_down_style svg_icon_xs ' + (loginMonthDate.currentMOM < 0 ? 'color_green' : 'color_red')"></svg-icon>
              </div>
            </div>
            <div class="statistics_yoy flex_center">
              <div class="statistics_mom_label"><span>{{ loginAccessStatus ? '月同比' : '日同比' }}</span></div>
              <div class="statistics_mom_info"><span>{{ loginAccessStatus ? Math.abs(loginMonthDate.currentYOY) : Math.abs(loginDate.currentYOY) }}%</span></div>
              <div v-if="!loginAccessStatus" class="statistics_mom_icon">
                <span v-if="loginDate.currentYOY === 0">--</span>
                <svg-icon v-else :iconClass="loginDate.currentYOY < 0 ? 'icon_triangle_down' : 'icon_triangle_top'"
                          :className="'icon_down_style svg_icon_xs ' + (loginDate.currentYOY < 0 ? 'color_green' : 'color_red')"></svg-icon>
              </div>
              <div v-else class="statistics_mom_icon">
                <span v-if="loginMonthDate.currentYOY === 0">--</span>
                <svg-icon v-else :iconClass="loginMonthDate.currentYOY < 0 ? 'icon_triangle_down' : 'icon_triangle_top'"
                          :className="'icon_down_style svg_icon_xs ' + (loginMonthDate.currentYOY < 0 ? 'color_green' : 'color_red')"></svg-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="sign_up_access_container">
        <div class="access_header flex_center">
          <div class="access_header_label"><span>系统用户注册量</span></div>
          <div class="access_header_info"><span>{{ signUpDate.totalNum }}</span></div>
        </div>
        <div class="access_content flex_center">
          <div class="statistics_nav flex_center">
            <div :class="['statistics_nav_data', {'statistics_nav_active': !signUpAccessStatus}]" @click="changeChart('reg', false, 'reg-d')"><span>日度</span></div>
            <div :class="['statistics_nav_month', {'statistics_nav_active': signUpAccessStatus}]" @click="changeChart('reg', true, 'reg-m')"><span>月度</span></div>
          </div>
          <div v-show="!signUpAccessStatus" class="time_container flex_center">
            <div class="time_input"><span ref="sign_up_access_data_start" id="sign_up_access_data_start"> {{ timeEl.signUpAccessData[0] }} </span></div>
            <div class="range_icon">
              <svg-icon iconClass="icon_range" className="icon_down_style svg_icon_xs color_219"></svg-icon>
            </div>
            <div class="time_input"><span ref="sign_up_access_data_end" id="sign_up_access_data_end">{{ timeEl.signUpAccessData[1] }}</span></div>
          </div>
          <div v-show="signUpAccessStatus" class="time_container flex_center">
            <div class="time_input"><span ref="sign_up_access_month_start" id="sign_up_access_month_start"> {{ timeEl.signUpAccessMonth[0] }} </span></div>
            <div class="range_icon">
              <svg-icon iconClass="icon_range" className="icon_down_style svg_icon_xs color_219"></svg-icon>
            </div>
            <div class="time_input"><span ref="sign_up_access_month_end" id="sign_up_access_month_end">{{ timeEl.signUpAccessMonth[1] }}</span></div>
          </div>
        </div>
        <div class="access_main">
          <div class="week_chart" v-show="!signUpAccessStatus"><div id="chart_sign_up_access_data" class="chart_main"></div></div>
          <div class="month_chart" v-show="signUpAccessStatus"><div id="chart_sign_up_access_month" class="chart_main"></div></div>
        </div>
        <div class="access_footer flex_center">
          <div class="today_container" :name="signUpMonthDate.currentMonth + '==' + signUpDate.currentDay"><span>{{ signUpAccessStatus ? '本月 ' + signUpMonthDate.currentMonth : '本日 ' + signUpDate.currentDay }}</span></div>
          <div class="statistics_container flex_center">
            <div class="statistics_mom flex_center">
              <div class="statistics_mom_label"><span>{{ signUpAccessStatus ? '月环比' : '日环比' }}</span></div>
              <div class="statistics_mom_info"><span>{{ signUpAccessStatus ? Math.abs(signUpMonthDate.currentMOM) : Math.abs(signUpDate.currentMOM) }}%</span></div>
              <div v-if="!signUpAccessStatus" class="statistics_mom_icon">
                <span v-if="signUpDate.currentMOM === 0">--</span>
                <svg-icon v-else :iconClass="signUpDate.currentMOM < 0 ? 'icon_triangle_down' : 'icon_triangle_top'"
                          :className="'icon_down_style svg_icon_xs ' + (signUpDate.currentMOM < 0 ? 'color_green' : 'color_red')"></svg-icon>
              </div>
              <div v-else class="statistics_mom_icon">
                <span v-if="signUpMonthDate.currentMOM === 0">--</span>
                <svg-icon v-else :iconClass="signUpMonthDate.currentMOM < 0 ? 'icon_triangle_down' : 'icon_triangle_top'"
                          :className="'icon_down_style svg_icon_xs ' + (signUpMonthDate.currentMOM < 0 ? 'color_green' : 'color_red')"></svg-icon>
              </div>
            </div>
            <div class="statistics_yoy flex_center">
              <div class="statistics_mom_label"><span>{{ signUpAccessStatus ? '月同比' : '日同比' }}</span></div>
              <div class="statistics_mom_info"><span>{{ signUpAccessStatus ? Math.abs(signUpMonthDate.currentYOY) : Math.abs(signUpDate.currentYOY) }}%</span></div>
              <div v-if="!signUpAccessStatus" class="statistics_mom_icon">
                <span v-if="signUpDate.currentYOY === 0">--</span>
                <svg-icon v-else :iconClass="signUpDate.currentYOY < 0 ? 'icon_triangle_down' : 'icon_triangle_top'"
                          :className="'icon_down_style svg_icon_xs ' + (signUpDate.currentYOY < 0 ? 'color_green' : 'color_red')"></svg-icon>
              </div>
              <div v-else class="statistics_mom_icon">
                <span v-if="signUpMonthDate.currentYOY === 0">--</span>
                <svg-icon v-else :iconClass="signUpMonthDate.currentYOY < 0 ? 'icon_triangle_down' : 'icon_triangle_top'"
                          :className="'icon_down_style svg_icon_xs ' + (signUpMonthDate.currentYOY < 0 ? 'color_green' : 'color_red')"></svg-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="stage_container">
      <div class="stage_header"><span>课程各阶段用户</span></div>
      <div class="stage_content flex_center">
        <div class="stage_main">
          <div class="chart_container"><div id="chart_stage_one" class="chart_main"></div></div>
          <div class="stage_info_container flex_center">
            <div class="stage_info stage_one_info flex_center">
              <div class="stage_info_label"><span>用户数</span></div>
              <div class="stage_info_text"><span>{{ videoStageClientTotal[0] }}</span></div>
            </div>
            <div class="stage_info stage_two_info flex_center">
              <div class="stage_info_label"><span>用户数</span></div>
              <div class="stage_info_text"><span>{{ videoStageClientTotal[1] }}</span></div>
            </div>
            <div class="stage_info stage_three_info flex_center">
              <div class="stage_info_label"><span>用户数</span></div>
              <div class="stage_info_text"><span>{{ videoStageClientTotal[2] }}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="video_data_container">
      <div class="video_data_header text_left"><span>课程视频数据</span></div>
      <div class="video_data_main">
        <div class="video_stage_container" v-for="(item, i) in videoStageDate" :key="i">
          <div class="video_stage_header flex_center">
            <div class="video_stage_label text_left"><span>{{ item.title }}</span></div>
            <div class="video_stage_info flex_center">
              <div class="video_stage_watch flex_center">
                <div class="video_stage_watch_label"><span>观看量</span></div>
                <div class="video_stage_watch_text"><span>{{ getVideoWatch(item.stage, 'watch') }}</span></div>
              </div>
              <div class="video_stage_download flex_center">
                <div class="video_stage_download_label"><span>下载量</span></div>
                <div class="video_stage_download_text"><span>{{ getVideoWatch(item.stage, 'download') }}</span></div>
              </div>
            </div>
            <div class="video_stage_icon" @click="item.stageStatus = !item.stageStatus">
              <svg-icon :className="'icon_down_style svg_icon_xs color_102 pointer_none ' + (!item.stageStatus ? 'svg_active': '')"
                        :iconClass="!item.stageStatus ? 'select_up' : 'select_down'"></svg-icon>
            </div>
          </div>
          <div class="video_stage_content" v-show="!item.stageStatus">
            <div class="video_stage_class_container flex_center" v-for="(stageItem, stageI) in item.stage" :key="stageI">
              <div class="video_stage_class_header flex_center">
                <div class="video_stage_class_title text_left"><span>{{ stageItem.videoTitle }}</span></div>
                <div class="video_stage_class_time"><span>{{ setTimeType(stageItem.video_duration) }}</span></div>
              </div>
              <div class="video_stage_info flex_center">
                <div class="video_stage_watch flex_center">
                  <div class="video_stage_watch_label"><span>观看量</span></div>
                  <div class="video_stage_watch_text"><span>{{ stageItem.play_num }}</span></div>
                </div>
                <div class="video_stage_download flex_center">
                  <div class="video_stage_download_label"><span>下载量</span></div>
                  <div class="video_stage_download_text"><span>{{ stageItem.download_num }}</span></div>
                </div>
              </div>
              <div class="video_stage_icon_places"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal :fa-visible="modalVisible" :header-title="modalTitle" @mmodal_close="modalClose" :is-footer="false">
      <template v-slot:modal_content>
        <template v-if="modalDay">
          <div class="modal_main">
            <div class="modal_main_header flex_center">
              <div><span>注册帐号</span></div>
              <div><span>父帐号</span></div>
            </div>
          </div>
          <div class="modal_main_content">
            <div class="no_user_hint" v-if="modalDate.length <= 0">{{ noDataHint }}</div>
            <div class="modal_main_container flex_center" v-for="(item, i) of modalDate" :key="i">
              <div><span>{{ item.name }}</span></div>
              <div><span>{{ item.val }}</span></div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="modal_main">
            <div class="client_active_user_header flex_center">
              <div><span>注册帐号</span></div>
              <div><span>客户数量</span></div>
              <div><span>活跃度</span></div>
              <div><span></span></div>
            </div>
          </div>
          <div class="modal_main_content">
            <div class="no_user_hint" v-if="modalActiveTimeDate.length <= 0">{{ noDataHint }}</div>
            <template v-for="(item, i) of modalActiveTimeDate">
              <div class="client_active_user_container flex_center" @click="catUserInfo(item)" :key="i">
                <div><span>{{ item.userName }}</span></div>
                <div><span>{{ item.clientNum }}</span></div>
                <div><span>{{ item.active_num }}</span></div>
                <div><svg-icon :className="'icon_down_style svg_icon_xs color_102 pointer_none'" :iconClass="'select_up'"></svg-icon></div>
              </div>
            </template>
          </div>
        </template>
      </template>
    </modal>
  </div>
</template>

<script>
import { Chart } from '@antv/g2'
import { _Ajax, initLogin, logout } from '@/api/_axios'
import { setThousandths, newMap, setTimeType, resetSpecNum } from '../common/common_js'
import modal from '@/components/modal/index'

export default {
  name: 'data-overview',
  components: {
    modal
  },
  data () {
    return {
      setTimeType: setTimeType,
      resetSpecNum: resetSpecNum,
      activeAccessStatus: false, // 活跃日度和月度切换的状态
      signUpDate: {}, // 系统注册日度数据
      signUpMonthDate: {}, // 系统注册月度数据
      signUpAccessStatus: false, // 用户注册页日度和月度切换的状态
      loginDate: {}, // 登录页访问日度数据
      loginMonthDate: {}, // 登录页访问月度数据
      loginAccessStatus: false, // 登录日度和月度切换的状态
      videoStageDate: [], // 课程视频数据
      activeUser: { // 单日活跃用户
        time: '',
        day: {
          active: 0,
          mom: 0,
          yoy: 0
        },
        week: {
          active: 0,
          mom: 0,
          yoy: 0
        },
        month: {
          active: 0,
          mom: 0,
          yoy: 0
        }
      },
      timeEl: { // 时间插件对应的element
        activeData: ['', ''],
        activeMonth: ['', ''],
        loginAccessData: ['', ''],
        loginAccessMonth: ['', ''],
        signUpAccessData: ['', ''],
        signUpAccessMonth: ['', ''],
        signIn: ['', '']
      },
      layDate: window.laydate, // 时间插件
      videoStageClientTotal: [], // 课程视频各阶段用户数
      modalVisible: false,
      modalTitle: '', // 单日注册用的模态框
      modalDate: [], // 单日注册用户的数据
      noDataHint: '', // 单日注册用户提示信息
      activeDetail: false, // 查看活跃用户的定义
      modalActiveDate: [], // 活跃用户的总数据
      modalActiveTimeDate: [], // 活跃用户的单日单月数据
      modalDay: true, // 是否是注册，否则打开活跃用户
      tempActiveWeekDate: [], // 周活跃用户的数据
      tempActiveMonthDate: [], // 月活跃用户的数据
      chartData: {} // 每个chart的赋值
    }
  },
  computed: {
    // 设置时间格式
    timeType: function () {
      return (time, str) => {
        return time.getFullYear() + str + (time.getMonth() > 8 ? '' : '0') + (time.getMonth() + 1) + str + (time.getDate() > 9 ? '' : '0') + time.getDate()
      }
    },
    // 计算时间的上一周或者下一周
    setTimeRange: function () {
      return (time, str) => {
        return str === 'prev' ? new Date(new Date(time).getTime() - 6 * 24 * 60 * 60 * 1000)
          : new Date(new Date(time).getTime() + 6 * 24 * 60 * 60 * 1000)
      }
    },
    // 设置月份格式
    setTimeMonth: function () {
      return (time, str) => {
        return time.getFullYear() + str + (time.getMonth() > 9 ? '' : '0') + (time.getMonth() + 1)
      }
    },
    // 计算时间的上七个月或者下七个月
    setTimeMonthRange: function () {
      return (time, str) => {
        time = new Date(time)
        let _month = time.getMonth() + 1
        let _year = time.getFullYear()
        if (str === 'prev') {
          if (_month - 6 < 1) {
            _year = _year - 1
            _month = 12 - Math.abs(_month - 6)
          } else {
            _month = _month - 6
          }
          return _year + '-' + _month
        } else {
          if (_month + 6 > 12) {
            _year = _year + 1
            _month = (_month + 6) - 12
          } else {
            _month = _month + 6
          }
          return _year + '-' + _month
        }
      }
    },
    // 获取视频观看量和下载量
    getVideoWatch: function () {
      return (arr, str) => {
        let watchTime = 0
        let downloadTime = 0
        for (let i of arr) {
          watchTime = watchTime + Number(i.play_num)
          downloadTime = downloadTime + Number(i.download_num)
        }
        if (str === 'watch') return setThousandths(watchTime)
        if (str === 'download') return setThousandths(downloadTime)
      }
    },
    // 设置tooltip样式
    setTooltipStyle: function () {
      return (type, iconColor) => {
        return '<li class="tooltip_diy flex_center">' +
          '<div class="tooltip_time_container"><span class="tooltip_time_icon" style="' + iconColor + '"></span><span class="tooltip_text">{time}</span></div>' +
          '<div><span class="tooltip_label">{num}</span></div>' +
          '<div><span class="tooltip_text">' + type + '环比</span><span class="tooltip_label">{mom}</span></div>' +
          '<div><span class="tooltip_text">' + type + '同比</span><span class="tooltip_label">{yoy}</span></div>' +
          '</li>'
      }
    },
    // 每月的最后一天
    setLastDayForMonth: function () {
      return (time) => {
        let tempYear = new Date(time).getFullYear()
        let tempMonth = new Date(time).getMonth() + 2
        let tempDay = new Date(time).getDate()
        if (tempMonth > 12) {
          tempYear = tempYear + 1
          tempMonth = tempMonth - 12
        }
        return new Date(tempYear + '-' + tempMonth + '-' + tempDay).getTime() - 1
      }
    }
  },
  methods: {
    // 单日活跃用户
    activeClient: function () {
      let that = this

      that.activeUser.time = that.timeType(new Date(), '-')

      // 单日活跃用户
      _Ajax(
        {
          method: 'post',
          url: '/data/overview/lively/day',
          clearCancelSource: true,
          params: {
            singleDate: that.activeUser.time
          }
        },
        (res) => {
          if (res.status === 401) {
            setTimeout(() => {
              that.$notice({type: 'error', content: '单日活跃用户：认证令牌错误！'})
              logout(that.$router)
            }, 0)
          } else if (res.status === 200) {
            res = res.data

            that.activeUser.day = {
              active: res.currentNum,
              mom: Number(res.currentQOQ),
              yoy: Number(res.currentYOY)
            }
          }
        },
        (rej) => { console.log('b--', rej) }
      )

      // 设置默认时间
      that.timeEl.activeData = [that.timeType(that.setTimeRange(new Date(), 'prev'), '-'), that.timeType(new Date(), '-')]
      that.timeEl.activeMonth = [that.setTimeMonthRange(new Date(), 'prev'), that.setTimeMonth(new Date(), '-')]

      getActiveWeek('init')
      getActiveMonth('init')

      function getActiveWeek (status) {
        that.noDataHint = '正在加载...'
        if (status === 'change') {
          that.modalActiveDate = []
        }
        _Ajax(
          {
            method: 'post',
            url: '/data/overview/lively/week',
            clearCancelSource: true,
            params: {
              startTime: that.timeEl.activeData[0],
              endTime: that.timeEl.activeData[1]
            }
          },
          (res) => {
            if (res.status === 401) {
              setTimeout(() => {
                that.$notice({type: 'error', content: '单日活跃用户：认证令牌错误！'})
                logout(that.$router)
              }, 0)
            } else if (res.status === 200) {
              res = res.data
              that.noDataHint = '没有符合条件的活跃账号!'

              let chartData = []

              // echart
              newMap(res['activeList'], (item) => {
                chartData.push({
                  time: item.day,
                  num: item.num,
                  yoy: that.resetSpecNum(item.chain_year) / 100,
                  mom: that.resetSpecNum(item.chain_day) / 100,
                  data: item.active_user
                })
              })

              let tempUserDate = that.activeUser

              tempUserDate.week = {
                active: res.weekNum,
                mom: Number(that.resetSpecNum(res.weekQOQ)),
                yoy: Number(that.resetSpecNum(res.weekYOY))
              }

              that.modalActiveDate = res.active_user
              that.tempActiveWeekDate = that.modalActiveDate

              // antv chart 柱状图
              if (status === 'change') {
                that.chartData['act-d'].changeData(chartData)
                that.modalActiveDate = that.tempActiveWeekDate
              } else if (status === 'init') {
                that.combinationChart('chart_active_day', chartData, 'interval', 'rgba(76, 139, 255, 1)',
                  {
                    style: that.setTooltipStyle('日', 'background-color: rgba(76, 139, 255, 1)'),
                    continue: (a) => {
                      that.chartData['act-d'] = a
                      a.on('interval:click', (ev) => {
                        const data = ev.target.get('element').getModel().data
                        that.modalVisible = true
                        that.modalDay = false
                        that.modalTitle = data.time
                        that.modalActiveTimeDate = data.data
                      })
                    }
                  }
                )
              }

              // 开始时间
              that.combinationLayDate('#client_active_data_start', 'date', that.timeEl.activeData[0],
                (v) => {
                  that.timeEl.activeData = [v, that.timeType(that.setTimeRange(v, 'next'), '-')]
                  that.$refs.client_active_data_end.textContent = that.timeEl.activeData[1]
                  getActiveWeek('change')
                }
              )
              // 结束时间
              that.combinationLayDate('#client_active_data_end', 'date', that.timeEl.activeData[1],
                (v) => {
                  that.timeEl.activeData = [that.timeType(that.setTimeRange(v, 'prev'), '-'), v]
                  that.$refs.client_active_data_start.textContent = that.timeEl.activeData[0]
                  getActiveWeek('change')
                }
              )
            }
          },
          (rej) => { console.log('b--', rej) }
        )
      }

      function getActiveMonth (status) {
        that.noDataHint = '正在加载...'
        if (status === 'change') {
          that.modalActiveDate = []
        }
        setTimeout(() => {
          _Ajax(
            {
              method: 'post',
              url: '/data/overview/lively/month',
              clearCancelSource: true,
              params: {
                startTime: that.timeEl.activeMonth[0] + '-01'
              }
            },
            (res) => {
              if (res.status === 401) {
                setTimeout(() => {
                  that.$notice({type: 'error', content: '单日活跃用户：认证令牌错误！'})
                  logout(that.$router)
                }, 0)
              } else if (res.status === 200) {
                res = res.data
                that.noDataHint = '没有符合条件的活跃账号!'

                let chartData = []

                // echart
                newMap(res['activeList'], (item) => {
                  chartData.push({
                    time: item.day,
                    num: item.num,
                    yoy: that.resetSpecNum(item.chain_year) / 100,
                    mom: that.resetSpecNum(item.chain_day) / 100,
                    data: item.active_user
                  })
                })

                let tempUserDate = that.activeUser

                tempUserDate.month = {
                  active: res.monthNum,
                  mom: res.monthQOQ ? Number(that.resetSpecNum(res.monthQOQ)) : 0,
                  yoy: res.monthYOY ? Number(that.resetSpecNum(res.monthYOY)) : 0
                }

                that.tempActiveMonthDate = res.active_user

                // antv chart 柱状图
                if (status === 'change') {
                  that.chartData['act-m'].changeData(chartData)
                  that.modalActiveDate = that.tempActiveMonthDate
                } else if (status === 'init') {
                  that.combinationChart('chart_active_month', chartData, 'interval', 'rgba(76, 139, 255, 1)',
                    {
                      style: that.setTooltipStyle('日', 'background-color: rgba(76, 139, 255, 1)'),
                      continue: (a) => {
                        that.chartData['act-m'] = a
                        a.option('scrollbar', {animate: false, categorySize: 60})
                        a.on('interval:click', (ev) => {
                          const data = ev.target.get('element').getModel().data
                          that.modalVisible = true
                          that.modalDay = false
                          that.modalTitle = data.time
                          that.modalActiveTimeDate = data.data
                        })
                      }
                    }
                  )
                }

                // 开始时间
                that.combinationLayDate('#client_active_month_start', 'month', that.timeEl.activeMonth[0],
                  (v) => {
                    that.timeEl.activeMonth = [v, that.setTimeMonthRange(new Date(v), 'next')]
                    getActiveMonth('change')
                  }
                )
              }
            },
            (rej) => { console.log('b--', rej) }
          )
        }, 1000)
      }
    },
    // 登录页访问量
    loginAccess: function () {
      let that = this

      that.loginDate = {}
      that.loginMonthDate = {}

      // 设置默认时间
      that.timeEl.loginAccessData = [that.timeType(that.setTimeRange(new Date(), 'prev'), '-'), that.timeType(new Date(), '-')]
      that.timeEl.loginAccessMonth = [that.setTimeMonthRange(new Date(), 'prev'), that.setTimeMonth(new Date(), '-')]

      getDayDate('init')
      getMonthDate('init')

      function getDayDate (status) {
        _Ajax(
          {
            method: 'post',
            url: '/data/overview/login_visit/day',
            clearCancelSource: true,
            params: {
              startTime: that.timeEl.loginAccessData[0],
              singleDate: that.timeType(new Date(), '-')
            }
          },
          (res) => {
            if (res.status === 200) {
              res = res.data

              let chartData = []

              that.loginDate = {
                currentDay: that.timeType(new Date(), '-'),
                currentMOM: that.resetSpecNum(res.currentQOQ),
                currentYOY: that.resetSpecNum(res.currentYOY),
                totalNum: res.totalNum
              }

              // echart
              newMap(res.numList, (item) => {
                chartData.push({
                  time: item.day,
                  num: item.num,
                  yoy: that.resetSpecNum(item.chain_year) / 100,
                  mom: that.resetSpecNum(item.chain_day) / 100
                })
              })

              // antv chart 柱状图
              if (status === 'change') {
                that.chartData['log-d'].changeData(chartData)
              } else if (status === 'init') {
                that.combinationChart('chart_login_access_data', chartData, 'interval', 'rgba(60, 222, 201, 1)',
                  {
                    style: that.setTooltipStyle('日', 'background-color: rgba(60, 222, 201, 1)'),
                    continue: (a) => {
                      that.chartData['log-d'] = a
                    }
                  }
                )
              }

              // 日度 开始时间
              that.combinationLayDate('#login_access_data_start', 'date', that.timeEl.loginAccessData[0],
                (v) => {
                  that.timeEl.loginAccessData = [v, that.timeType(that.setTimeRange(v, 'next'), '-')]
                  that.$refs.login_access_data_end.textContent = that.timeEl.loginAccessData[1]
                  getDayDate('change')
                }
              )
              // 日度 结束时间
              that.combinationLayDate('#login_access_data_end', 'date', that.timeEl.loginAccessData[1],
                (v) => {
                  that.timeEl.loginAccessData = [that.timeType(that.setTimeRange(v, 'prev'), '-'), v]
                  that.$refs.login_access_data_start.textContent = that.timeEl.loginAccessData[0]
                  getDayDate('change')
                }
              )
            }
          },
          (rej) => { console.log('b--', rej) }
        )
      }

      function getMonthDate (status) {
        _Ajax(
          {
            method: 'post',
            url: '/data/overview/login_visit/month',
            clearCancelSource: true,
            params: {
              startTime: that.timeEl.loginAccessMonth[0] + '-01',
              singleDate: that.timeType(new Date(), '-')
            }
          },
          (res) => {
            if (res.status === 200) {
              res = res.data

              that.loginMonthDate.currentMonth = that.setTimeMonth(new Date(), '-')

              let chartData = []

              // echart
              newMap(res.numList, (item) => {
                if (status === 'init' && (new Date().getFullYear() + '-' + (new Date().getMonth() < 9 ? '0' : '') + (new Date().getMonth() + 1) + '-01') === item.day) {
                  that.loginMonthDate.currentMOM = that.resetSpecNum(item.chain_day)
                  that.loginMonthDate.currentYOY = that.resetSpecNum(item.chain_year)
                }
                chartData.push({
                  time: item.day.substring(0, item.day.length - 3),
                  num: item.num,
                  yoy: that.resetSpecNum(item.chain_year) / 100,
                  mom: that.resetSpecNum(item.chain_day) / 100
                })
              })

              // antv chart 柱状图
              if (status === 'change') {
                that.chartData['log-m'].changeData(chartData)
              } else if (status === 'init') {
                that.combinationChart('chart_login_access_month', chartData, 'interval', 'rgba(60, 222, 201, 1)',
                  {
                    style: that.setTooltipStyle('月', 'background-color: rgba(60, 222, 201, 1)'),
                    continue: (a) => {
                      that.chartData['log-m'] = a
                    }
                  }
                )
              }

              // 月度 开始时间
              that.combinationLayDate('#login_access_month_start', 'month', that.timeEl.loginAccessMonth[0],
                (v) => {
                  that.timeEl.loginAccessMonth = [v, that.setTimeMonthRange(new Date(v), 'next')]
                  that.$refs.login_access_month_end.textContent = that.timeEl.loginAccessMonth[1]
                  getMonthDate('change')
                }
              )
              // 月度 结束时间
              that.combinationLayDate('#login_access_month_end', 'month', that.timeEl.loginAccessMonth[1],
                (v) => {
                  that.timeEl.loginAccessMonth = [that.setTimeMonthRange(new Date(v), 'prev'), v]
                  that.$refs.login_access_month_start.textContent = that.timeEl.loginAccessMonth[0]
                  getMonthDate('change')
                }
              )
            }
          },
          (rej) => { console.log('b--', rej) }
        )
      }
    },
    // 系统用户注册量
    signUpAccess: function () {
      let that = this

      that.signUpDate = {}
      that.signUpMonthDate = {}

      // 设置默认时间
      that.timeEl.signUpAccessData = [that.timeType(that.setTimeRange(new Date(), 'prev'), '-'), that.timeType(new Date(), '-')]
      that.timeEl.signUpAccessMonth = [that.setTimeMonthRange(new Date(), 'prev'), that.setTimeMonth(new Date(), '-')]

      getDayDate('init')
      getMonthDate('init')

      function getDayDate (status) {
        _Ajax(
          {
            method: 'post',
            url: '/data/overview/register/day',
            clearCancelSource: true,
            params: {
              startTime: that.timeEl.signUpAccessData[0],
              singleDate: that.timeType(new Date(), '-')
            }
          },
          (res) => {
            if (res.status === 401) {
              setTimeout(() => {
                that.$notice({type: 'error', content: '系统用户注册日度：认证令牌错误！'})
                logout(that.$router)
              }, 0)
            } else if (res.status === 200) {
              res = res.data

              let chartData = []

              that.signUpDate = {
                currentDay: res.currentDay,
                currentMOM: that.resetSpecNum(res.currentQOQ),
                currentYOY: that.resetSpecNum(res.currentYOY),
                totalNum: res.totalNum
              }

              // echart
              newMap(res['numList'], (item) => {
                chartData.push({
                  time: item.day,
                  num: item.num,
                  yoy: that.resetSpecNum(item.chain_year) / 100,
                  mom: that.resetSpecNum(item.chain_day) / 100
                })
              })

              // antv chart 柱状图
              if (status === 'change') {
                that.chartData['reg-d'].changeData(chartData)
              } else if (status === 'init') {
                that.combinationChart('chart_sign_up_access_data', chartData, 'line', 'rgba(76, 139, 255, 1)',
                  {
                    style: that.setTooltipStyle('日', 'background-color: rgba(76, 139, 255, 1)'),
                    continue: (a) => {
                      that.chartData['reg-d'] = a

                      // 单日用户注册的触发事件（使用plot，触发整个canvas的绘图区）（仅判断x，根据点击的x值，判断是否在出发区域，第一个和最后一个只需要出发一部分）
                      a.on('plot:click', (ev) => {
                        let data = a.geometries[0].dataArray[0]
                        let spaceX = (data[1].x - data[0].x) / 2
                        let startX = data[0].x
                        let endX = data[data.length - 1].x
                        if (ev.x >= startX && ev.x < (startX + spaceX)) {
                          that.modalShow(data[0]._origin.time)
                        } else if (ev.x < endX && ev.x >= (endX - spaceX)) {
                          that.modalShow(data[data.length - 1]._origin.time)
                        } else {
                          data.forEach((arr, i) => {
                            if (i !== 0 && i !== data.length - 1) {
                              if (ev.x >= (arr.x - spaceX) && ev.x < (arr.x + spaceX)) {
                                that.modalShow(arr._origin.time)
                              }
                            }
                          })
                        }
                      })
                    }
                  }
                )
              }

              // 日度 开始时间
              that.combinationLayDate('#sign_up_access_data_start', 'date', that.timeEl.signUpAccessData[0],
                (v) => {
                  that.timeEl.signUpAccessData = [v, that.timeType(that.setTimeRange(v, 'next'), '-')]
                  that.$refs.sign_up_access_data_end.textContent = that.timeEl.signUpAccessData[1]
                  getDayDate('change')
                }
              )
              // 日度 结束时间
              that.combinationLayDate('#sign_up_access_data_end', 'date', that.timeEl.signUpAccessData[1],
                (v) => {
                  that.timeEl.signUpAccessData = [that.timeType(that.setTimeRange(v, 'prev'), '-'), v]
                  that.$refs.sign_up_access_data_start.textContent = that.timeEl.signUpAccessData[0]
                  getDayDate('change')
                }
              )
            }
          },
          (rej) => { console.log('b--', rej) }
        )
      }

      function getMonthDate (status) {
        _Ajax(
          {
            method: 'post',
            url: '/data/overview/register/month',
            clearCancelSource: true,
            params: {
              startTime: that.timeEl.signUpAccessMonth[0] + '-01',
              singleDate: that.timeType(new Date(), '-')
            }
          },
          (res) => {
            if (res.status === 401) {
              setTimeout(() => {
                that.$notice({type: 'error', content: '系统用户注册月度：认证令牌错误！'})
                logout(that.$router)
              }, 0)
            } else if (res.status === 200) {
              res = res.data

              that.signUpMonthDate.currentMonth = that.setTimeMonth(new Date(res.currentMonth), '-')

              let chartData = []

              // echart
              newMap(res['numList'], (item) => {
                if (status === 'init' && (new Date().getFullYear() + '-' + (new Date().getMonth() < 9 ? '0' : '') + (new Date().getMonth() + 1) + '-01') === item.day) {
                  that.signUpMonthDate.currentMOM = that.resetSpecNum(item.chain_day)
                  that.signUpMonthDate.currentYOY = that.resetSpecNum(item.chain_year)
                }
                chartData.push({
                  time: item.day.substring(0, item.day.length - 3),
                  num: item.num,
                  yoy: that.resetSpecNum(item.chain_year) / 100,
                  mom: that.resetSpecNum(item.chain_day) / 100
                })
              })

              // antv chart 柱状图
              if (status === 'change') {
                that.chartData['reg-m'].changeData(chartData)
              } else if (status === 'init') {
                that.combinationChart('chart_sign_up_access_month', chartData, 'line', 'rgba(76, 139, 255, 1)',
                  {
                    style: that.setTooltipStyle('月', 'background-color: rgba(76, 139, 255, 1)'),
                    continue: (a) => {
                      that.chartData['reg-m'] = a
                      a.on('plot:click', (ev) => {
                        let data = a.geometries[0].dataArray[0]
                        let spaceX = (data[1].x - data[0].x) / 2
                        let startX = data[0].x
                        let endX = data[data.length - 1].x
                        if (ev.x >= startX && ev.x < (startX + spaceX)) {
                          that.modalShow(data[0]._origin.time, 'month')
                        } else if (ev.x < endX && ev.x >= (endX - spaceX)) {
                          that.modalShow(data[data.length - 1]._origin.time, 'month')
                        } else {
                          data.forEach((arr, i) => {
                            if (i !== 0 && i !== data.length - 1) {
                              if (ev.x >= (arr.x - spaceX) && ev.x < (arr.x + spaceX)) {
                                that.modalShow(arr._origin.time, 'month')
                              }
                            }
                          })
                        }
                      })
                    }
                  }
                )
              }

              // 月度 开始时间
              that.combinationLayDate('#sign_up_access_month_start', 'month', that.timeEl.signUpAccessMonth[0],
                (v) => {
                  that.timeEl.signUpAccessMonth = [v, that.setTimeMonthRange(new Date(v), 'next')]
                  that.$refs.sign_up_access_month_end.textContent = that.timeEl.signUpAccessMonth[1]
                  getMonthDate('change')
                }
              )
              // 月度 结束时间
              that.combinationLayDate('#sign_up_access_month_end', 'month', that.timeEl.signUpAccessMonth[1],
                (v) => {
                  that.timeEl.signUpAccessMonth = [that.setTimeMonthRange(new Date(v), 'prev'), v]
                  that.$refs.sign_up_access_month_start.textContent = that.timeEl.signUpAccessMonth[0]
                  getMonthDate('change')
                }
              )
            }
          },
          (rej) => { console.log('b--', rej) }
        )
      }
    },
    // 课程各阶段用户
    stageClient: function () {
      let that = this

      _Ajax(
        {
          method: 'get',
          url: '/data/overview/course',
          clearCancelSource: true
        },
        (res) => {
          if (res.status === 401) {
            setTimeout(() => {
              that.$notice({type: 'error', content: '课程各阶段用户：认证令牌错误！'})
              logout(that.$router)
            }, 0)
          } else if (res.status === 200) {
            res = res.data

            let chartData = []

            newMap(
              res.levelList,
              (item, i) => {
                chartData.push({
                  type: item.title,
                  value: that.resetSpecNum(item.ratio)
                })

                // 设置用户数
                that.videoStageClientTotal.push(item.total)
              }
            )

            const chart = new Chart({
              container: 'chart_stage_one',
              autoFit: true
            })
            chart.data(chartData)
            chart.legend(false)
            chart.tooltip({
              showMarkers: false // 每一块上面会有一个圆点
            })

            chart.on('tooltip:show', (e) => {
              // eslint no-throw-literal: 2
              if (e.data.title === '其他') throw 'other don`t emit tooltip'
            })

            // 事件
            chart.facet('rect', {
              fields: ['type'],
              padding: [50, 50, 20, 50], // 外圈的距离（每个饼图最外面有一个看不见的框）
              showTitle: false,
              eachView: (view, facet) => {
                const data = facet.data
                let color
                if (data[0].type === '一阶段') {
                  color = 'rgba(76, 139, 255, 1)'
                } else if (data[0].type === '二阶段') {
                  color = 'rgba(76, 198, 255, 1)'
                } else if (data[0].type === '三阶段') {
                  color = 'rgba(60, 222, 201, 1)'
                }
                data.push({ type: '其他', value: 100 - data[0].value })
                view.data(data)
                view.coordinate('theta', {
                  radius: 1, // 外圈圆大小
                  innerRadius: 0.7667 // 内圈圆大小
                })

                // 其他的样式
                view.interval()
                  .adjust('stack')
                  .position('value')
                  .color('type', [color, 'rgba(240, 242, 245, 1)']) // 其他的环的样式
                  .style({
                    opacity: 1
                  })
                  .state({
                    active: { // 悬浮事件 interface.d.ts - ShapeMarkerAttrs
                      style: element => {
                        if (element.data.type !== '其他') {
                          return {
                            lineWidth: 2, // 描边宽度
                            stroke: 'rgba(202, 202, 202, 1)' // 描边颜色
                          }
                        } else {
                          return {}
                        }
                      }
                    }
                  })

                // 圆内label的样式
                view.annotation().text({
                  position: [ '50%', '50%' ],
                  content: data[0].type,
                  style: {
                    fontSize: 16,
                    fill: 'rgba(102, 102, 102, 1)',
                    fontWeight: 500,
                    textBaseline: 'bottom',
                    textAlign: 'center'
                  },
                  offsetY: -12
                })

                // 圆内数字的样式
                view.annotation().text({
                  position: ['50%', '50%'],
                  content: data[0].value,
                  style: {
                    fontSize: 24,
                    fill: 'rgba(40, 40, 40, 1)',
                    fontWeight: 800,
                    textAlign: 'center'
                  },
                  offsetY: 16
                })

                view.interaction('element-active')
              }
            })

            chart.render()
          }
        },
        (rej) => { console.log('b--', rej) }
      )
    },
    // 获取课程视频数据
    getVideoStageDate: function () {
      let that = this

      _Ajax(
        {
          method: 'get',
          url: '/data/overview/video',
          clearCancelSource: true
        },
        (res) => {
          if (res.status === 401) {
            setTimeout(() => {
              that.$notice({type: 'error', content: '课程视频数据：认证令牌错误！'})
              logout(that.$router)
            }, 0)
          } else if (res.status === 200) {
            res = res.data

            that.videoStageDate = []

            newMap(res, (item) => {
              that.videoStageDate.push({
                title: item.courseTitle,
                stageStatus: false,
                stage: item.video
              })
            })
          }
        },
        (rej) => { console.log('b--', rej) }
      )
    },
    // 封装 chart
    combinationChart: function (el, date, _type, _color, tooltip) {
      let that = this
      if (typeof tooltip.continue === 'undefined') tooltip.continue = () => {}
      if (typeof _color === 'undefined') _color = ''

      const chart = new Chart({
        container: el,
        renderer: 'svg',
        autoFit: true,
        height: 200
      })
      chart.data(date)

      // 设置两边留白，range[底部边距,顶部边距]
      chart.scale('num', {
        tickCount: 5,
        nice: true,
        tickMethod: (v) => {
          const { min, max } = v
          const avg = Math.ceil((max - min) / 3)
          let ticks = []

          // 最大值与最小值差的平均数是否小于1，小于1则自定义y轴刻度（因为没有刻度可以显示）
          if (Math.max.apply(0, v.ticks) === -Infinity) {
            for (let i = 0; i <= 5; i++) {
              if (avg < 1) {
                ticks.push(i)
              } else {
                ticks.push(avg * i)
              }
            }
          } else {
            if (Math.max.apply(0, v.ticks) <= Math.max.apply(0, v.values)) {
              for (let i = 0; i <= 5; i++) {
                if (avg < 1) {
                  ticks.push(i)
                } else {
                  ticks.push(avg * i)
                }
              }
            } else {
              ticks = v.ticks
            }
          }

          return ticks
        }
      })

      tooltip.continue(chart)

      chart.scale('time', {
        range: [0.05, 0.95]
      })

      // 隐藏x轴 label为''则隐藏
      chart.axis('time', {
        label: ''
      })

      if (_type === 'line') {
        chart.tooltip({
          itemTpl: tooltip.style,
          showTitle: false,
          showMarkers: true // 每一块上面会有一个圆点
        })

        chart.line().position('time*num')
          .color(_color)
          .tooltip('time*num*yoy*mom', (time, num, yoy, mom) => {
            return {
              time: time,
              num: num,
              yoy: that.resetSpecNum(yoy) + '%',
              mom: that.resetSpecNum(mom) + '%'
            }
          })
      } else if (_type === 'interval') {
        chart.tooltip({
          itemTpl: tooltip.style,
          showTitle: false,
          showMarkers: false // 每一块上面会有一个圆点
        })

        chart.interval().position('time*num')
          .color(_color)
          .tooltip('time*num*yoy*mom', (time, num, yoy, mom) => {
            return {
              time: time,
              num: num,
              yoy: that.resetSpecNum(yoy) + '%',
              mom: that.resetSpecNum(mom) + '%'
            }
          })
      }
      chart.render()
    },
    // 封装 layDate
    combinationLayDate: function (el, type, val, res) {
      this.layDate.render({
        elem: el,
        trigger: 'click',
        type: type,
        value: val,
        done: function (val) {
          res(val)
        }
      })
    },
    // 单日用户注册模态框
    modalClose: function (data) {
      this.modalVisible = false
    },
    // 打开
    modalShow: function (time, str) {
      let that = this
      that.modalDay = true
      that.modalVisible = true
      that.modalTitle = time
      that.modalDate = []
      that.noDataHint = '正在加载...'

      if (typeof str === 'undefined') str = ''
      let tempStartTime = time
      let tempLastTime = time
      if (str === 'month') {
        tempStartTime = that.modalTitle + '-01'
        tempLastTime = that.timeType(new Date(that.setLastDayForMonth(tempStartTime)), '-')
      }

      _Ajax(
        {
          method: 'post',
          url: '/data/register/user',
          clearCancelSource: true,
          params: {
            startTime: tempStartTime,
            endTime: tempLastTime
          }
        },
        (res) => {
          if (res.status === 401) {
            setTimeout(() => {
              that.$notice({type: 'error', content: '注册用户：认证令牌错误！'})
              logout(that.$router)
            }, 0)
          } else if (res.status === 200) {
            res = res.data

            if (res) {
              newMap(
                res,
                (item) => {
                  that.modalDate.push({
                    name: item.user_account,
                    val: item.parent_account ? item.parent_account : '--'
                  })
                }
              )
            }

            if (that.modalDate && that.modalDate.length <= 0) {
              that.noDataHint = '没有符合条件的活跃账号!'
            }
          }
        }
      )
      // that.modalDate = [
      //   {name: 'a', val: 1},
      //   {name: 'a1', val: 13},
      //   {name: 'a2', val: 12},
      //   {name: 'a3', val: 14},
      //   {name: 'a3', val: 14},
      //   {name: 'a3', val: 14},
      //   {name: 'a3', val: 14},
      //   {name: 'a3', val: 14},
      //   {name: 'a4', val: 15}
      // ]
      console.log(time)
    },
    // 活跃用户的状态
    catActiveDetail: function (e) {
      e.stopPropagation()
      let that = this
      that.activeDetail = !that.activeDetail
    },
    // 查看用户的详细信息
    catUserInfo: function (e) {
      let that = this

      that.$nextTick(() => {
        window.open(window.location.href.split('/date')[0] + `/user/index?account=${true}&team=${e.customerId}&name=${e.userName}&id=${e.userId}`, '', '_blank')
      })
    },
    // chart跟随窗口大小改变
    changeChart: function (data, status, str) {
      let that = this
      if (data === 'act') {
        that.activeAccessStatus = status
        that.modalActiveDate = str === 'act-d' ? that.tempActiveWeekDate : that.tempActiveMonthDate
      }

      if (data === 'log') {
        that.loginAccessStatus = status
      }

      if (data === 'reg') {
        that.signUpAccessStatus = status
      }

      that.chartData[str].onResize()
    },
    // 每个模块的执行顺序
    modelRun: function () {
      let that = this

      that.activeClient('create')

      setTimeout(() => {
        that.loginAccess()
      }, 1000)

      setTimeout(() => {
        that.signUpAccess()
      }, 1500)

      setTimeout(() => {
        that.stageClient()
      }, 2500)

      setTimeout(() => {
        that.getVideoStageDate()
      }, 3000)
    },
    // 测试接口是否有效
    getUser: function (call) {
      let that = this
      _Ajax(
        {
          method: 'get',
          url: '/api/profileManagement/home'
        },
        (res) => {
          if (res.status === 401) {
            that.$notice({type: 'error', content: '登录已失效，请重新登录！'})
            logout(that.$router)
          } else if (res.status === 200) {
            call()
          }
        },
        (rej) => { console.log('b--', rej) }
      )
    }
  },
  mounted: function () {
    let that = this
    let dom = document.querySelector('#app')

    let tempLogoutStatus = true
    initLogin(that.$router, () => {
      tempLogoutStatus = false
    })

    if (tempLogoutStatus) {
      that.getUser(() => {
        that.modelRun()
      })
    } else {
      that.$notice({type: 'error', content: '登录已失效，请重新登录！'})
    }

    dom.addEventListener('click', function () {
      if (that.activeDetail) {
        that.activeDetail = false
      } else {
        dom.removeEventListener('click', undefined, false)
      }
    }, false)
  }
}
</script>

<style scoped>
.page_data_overview > div:not(.modal_dialog) {background-color: rgba(255, 255, 255, 1);border-radius: 6px}
.chart_container {width: 100%}

/* 单日活跃用户 */
.day_active_container {padding: 32px 30px;justify-content: flex-start}
.day_active_user_icon {margin-right: 40px}
.day_active_user_icon >>> svg {width: 45px;height: 60px}
.client_active_cycle_nav {justify-content: flex-start;align-items: flex-start}
.client_active_cycle_nav .statistics_nav {margin-left: 70px}

.active_detail_icon {margin-left: 10px;cursor: pointer;position: relative}
.active_detail_icon:hover >>> svg {fill: rgba(76, 139, 255, 1)}
.active_detail {width: 400px;z-index: 9;position: absolute;left: 30px;top: -34px;text-align: left;background-color: rgba(63, 70, 77, 1);border-radius: 4px;padding: 12px 16px}
.client_active_cycle_label .active_detail_container span {line-height: 1.3;font-size: 14px;font-weight: 400;color: rgba(255, 255, 255, 1)}

/* 活跃用户 */
.client_active_container {margin-top: 20px;padding: 34px 24px 40px;justify-content: space-between;align-items: flex-start}
.client_active_main {width: 50%;flex-flow: column;align-items: flex-start}
.today_container {padding-left: 15px}
.client_active_header {align-items: flex-start}
.client_active_data {flex-flow: column;justify-content: flex-start;align-items: flex-start}
.client_active_data span:first-of-type {font-size: 14px;font-weight: 400;color: rgba(102, 102, 102, 1)}
.client_active_data span:last-of-type {margin-top: 12px;font-size: 34px;font-weight: bold;color: rgba(40, 40, 40, 1)}
.client_active_info {margin-left: 10px}
.client_active_info .statistics_container {margin-top: 24px}

.client_active_user_main {height: 228px;overflow-y: auto}

.client_active_user {margin-top: 28px}
.client_active_user_header {background: rgba(248, 248, 249, 1);border-bottom: 1px solid rgba(235, 235, 235, 1);border-top: 1px solid rgba(235, 235, 235, 1)}
.client_active_user_header, .client_active_user_container {padding: 0 20px;text-align: left;justify-content: flex-start;height: 40px}
.client_active_user_header > div:nth-of-type(1), .client_active_user_container > div:nth-of-type(1) {width: 40%}
.client_active_user_header > div:nth-of-type(2), .client_active_user_container > div:nth-of-type(2) {width: 30%}
.client_active_user_header > div:nth-of-type(3), .client_active_user_container > div:nth-of-type(3) {width: 20%}
.client_active_user_header > div:nth-of-type(4), .client_active_user_container > div:nth-of-type(4) {width: 10%}
.client_active_user_container {cursor: pointer;border-bottom: 1px solid rgba(235, 235, 235, 1)}
.client_active_user_header span {font-size: 14px;font-weight: 500;color: #282828;}
.client_active_user_container span {font-size: 14px;font-weight: 400;color: rgb(102, 102, 102)}
.client_active_user_container >>> svg {transform: rotate(90deg)}
.client_active_user_container:hover >>> svg {fill: rgba(76, 139, 255, 1)}

/* 本日 */
.today_container span {font-size: 14px;font-weight: 400;color: rgba(102, 102, 102, 1)}

/* 环比和同比 */
.statistics_mom_label span {font-size: 14px;font-weight: 400;color: rgba(102, 102, 102, 1)}
.statistics_mom_info {margin-left: 13px}
.statistics_mom_info span {font-size: 14px;font-weight: bold;color: rgba(40, 40, 40, 1)}
.statistics_mom_icon {margin-left: 8px}
.statistics_yoy {margin-left: 40px}

.client_active_cycle_header {flex-flow: column;align-items: flex-start}
.client_active_cycle_main .client_active_cycle_container:first-of-type {margin-top: 0}
.client_active_cycle_container {padding-left: 6px}
.client_active_cycle_label span {font-size: 14px;font-weight: 400;color: rgba(102, 102, 102, 1)}
.client_active_cycle_info {margin-top: 12px}
.client_active_cycle_info span {font-size: 34px;font-weight: bold;color: rgba(40, 40, 40, 1)}
.client_active_cycle_container .statistics_container {justify-content: flex-start;margin-top: 20px}

.client_active_cycle_main {width: 49%}
.client_active_cycle_main .time_container {margin-top: 0;margin-left: auto}
.client_active_cycle_main .time_month_container {max-width: 100px}
.client_active_main .chart_main {margin-top: 40px;padding-left: 0}

/* 登录页 */
.page_data_overview > div.access_container {background-color: transparent}
.access_container {justify-content: space-between;margin-top: 20px;align-items: flex-start}
.access_container > div {width: 49%;background-color: rgba(255, 255, 255, 1);border-radius: 6px;padding-bottom: 26px}
.access_header {border-bottom: 1px solid rgba(235, 235, 235, 1);padding: 23px 23px 15px;justify-content: flex-start}
.access_header_label span {font-size: 14px;font-weight: 400;color: rgba(102, 102, 102, 1)}
.access_header_info {margin-left: 26px}
.access_header_info span {font-size: 34px;font-weight: bold;color: rgba(40, 40, 40, 1)}

.access_content {margin-top: 15px;justify-content: space-between;padding: 0 25px 26px 25px}
.statistics_nav span {cursor: pointer;font-size: 14px;font-weight: 400;color: rgba(102, 102, 102, 1)}
.statistics_nav_month {margin-left: 20px}
.statistics_nav .statistics_nav_active span {color: rgba(76, 139, 255, 1)}
.access_content .time_container {margin-top: 0}

.access_main {padding-top: 15px}
.access_footer {justify-content: flex-start;padding-left: 24px;margin-top: 32px}
.access_footer .statistics_container {margin-left: 58px}

/* 课程各阶段用户 */
.stage_container {margin-top: 20px;padding: 32px 23px}
.stage_main {width: 100%}
.stage_container .chart_main {padding-left: 0;height: 250px}
.stage_container .chart_container {margin-top: 0}
.stage_header {text-align: left}
.stage_header span {font-size: 14px;font-weight: 400;color: rgba(102, 102, 102, 1)}
.stage_info_container {justify-content: space-around;width: 95%}
.stage_info {flex-flow: column;align-items: flex-start;justify-content: flex-start}
.stage_info_label span {font-size: 14px;font-weight: 400;color: rgba(102, 102, 102, 1)}
.stage_info_text {margin-top: 12px}
.stage_info_text span {font-size: 34px;font-weight: bold;color: rgba(40, 40, 40, 1)}

/* 课程视频数据 */
.video_data_container {padding: 32px 22px;margin-top: 20px}
.video_data_header span {font-size: 14px;font-weight: 400;color: rgba(102, 102, 102, 1)}
.video_data_main {margin-top: 18px}

.video_stage_header {justify-content: space-between;height: 54px;padding-right: 18px;background-color: rgba(248, 248, 248, 1)}
.video_stage_label {min-width: 500px}
.video_stage_label span {border-left: 4px solid rgba(61, 168, 245, 1);padding-left: 17px;font-size: 18px;font-weight: 500;color: rgba(48, 48, 48, 1)}

.video_stage_watch_label span,
.video_stage_download_label span {font-size: 16px;font-weight: 400;color: rgba(102, 102, 102, 1)}
.video_stage_watch_text span,
.video_stage_download_text span {font-size: 16px;font-weight: bold;color: rgba(40, 40, 40, 1)}
.video_stage_watch_text, .video_stage_download_text {margin-left: 16px}
.video_stage_download, .video_stage_watch {justify-content: flex-start;width: 194px}

.video_stage_icon {line-height: 50px;padding: 0 10px;cursor: pointer}
.video_stage_icon_places {width: 36px;height: 20px}

.video_stage_container {border-bottom: 1px solid rgba(235, 235, 235, 1)}
.video_stage_class_container {cursor: pointer;justify-content: space-between;height: 58px;border-top: 1px solid rgba(235, 235, 235, 1);padding-right: 18px}
.video_stage_class_container:hover .video_stage_class_title span {color: rgba(61, 168, 245, 1)}
.video_stage_class_header {justify-content: flex-start;width: 500px}
.video_stage_class_title {width: 100%}
.video_stage_class_title span {padding-left: 21px;font-size: 16px;font-weight: 400;color: rgba(48, 48, 48, 1)}
.video_stage_class_time {min-width: 186px}
.video_stage_class_time span {font-size: 14px;font-weight: 400;color: rgba(96, 96, 96, 1)}

.video_stage_class_container .video_stage_watch_label span,
.video_stage_class_container .video_stage_download_label span {font-size: 14px}
.video_stage_class_container .video_stage_watch_text span,
.video_stage_class_container .video_stage_download_text span {font-size: 14px}
.video_stage_class_container .video_stage_watch_text, .video_stage_class_container .video_stage_download_text {margin-left: 12px}

/* 单日用户注册显示 */
.modal_main_header {text-align: left;background: rgba(248, 248, 249, 1)}
.modal_main_container {border-bottom: 1px solid rgba(235, 235, 235, 1)}
.modal_main_header div {width: 50%;padding-left: 24px;height: 50px;line-height: 50px;border-top: 1px solid rgba(235, 235, 235, 1);border-bottom: 1px solid rgba(235, 235, 235, 1)}
.modal_main_header span {font-size: 14px;font-weight: 400;color: #666666}
.modal_main_container span {color: rgba(40, 40, 40, 1);font-size: 14px;font-weight: 500}
.modal_main_container div {text-align: left;width: 50%;padding-left: 24px;height: 50px;line-height: 50px}
.modal_main_content {height: 260px;overflow: hidden;overflow-y: scroll}

/* 提示信息 */
.no_user_hint {margin: 30px 0}
.no_user_hint span {font-size: 16px;font-weight: 500;color: rgba(143, 143, 143, 1)}
</style>



// WEBPACK FOOTER //
// src/components/page-date/index.vue